module.exports = __webpack_public_path__ + "res/img_reward_t.feefd9afc52a0050551b2bf65dea81b1.png";